<template>
  <section :class="this.$Base.checkSysteam() == 'MOBILE' ? 'mldy' : 'ldy'">
    <!-- <div class="mheader" v-if="this.$Base.checkSysteam() == 'MOBILE'">
      <div data-v-6f16fb9e="" class="logo">
        <img src="../../assets/logo.png" alt=""></div>
    </div> -->
    <div class="verified-logo" v-if="this.$Base.langPicClass() == 'vi-VN'">
      <img src="../../assets/vi/18X.png" alt="" />
    </div>
    <div class="cc">
      <div class="content" :class="styleName ? 'styleTop' : ''">
        <div class="vi-logo" v-if="this.$Base.langPicClass() == 'vi-VN'">
          <img src="../../assets/vi/logo.png" alt="" />
        </div>
        <div v-else class="logo">
          <img src="../../assets/logo.png" alt="" />
        </div>
        <!-- 导航 -->
        <rastar-nav
          :appId="urlData.appid"
          :pId="urlData.pid"
          :mdId="urlData.md_id"
          :ukey="urlData.ukey"
          :msgVal="isMsgVal"
          :initialization="initialization"
          :system="isSystem"
          :getCodeShow="getCodeShow"
        ></rastar-nav>
      </div>
    </div>
    <!-- 底部 -->
    <rastar-footer></rastar-footer>
  </section>
</template>

<script>
import RastarNav from "../../components/nav/template.vue";
import rastarFooter from "../../components/footer/template.vue";

import { RSSign, RSMD5 } from "../../utils/sign.js";
export default {
  name: "ldy",
  data() {
    return {
      urlData: null,
      isMsgVal: 0,
      msgFormSon: "wo shi ceshi",
      initialization: false,
      isSystem: "",
      styleName: false,
    };
  },
  props: ["appId", "pId", "mdId", "ukey", "msgVal"],
  components: {
    RastarNav,
    rastarFooter,
  },
  methods: {
    getCodeShow(name) {
      console.log("登陆首页收到了子组件的name", name);
      this.styleName = name;
    },
    // 获取url中的cch_id、app_id，供登录使用
    getId(url) {
      url = url.split("/");
      return {
        // 游戏id app_id
        appid: url[3],
        // 渠道id p_id
        pid: url[4],
        ukey: url[7],
        md_id: url[8],
      };
    },
    // 初始化接口
    init() {
      let deviceIdUa = this.$Storage.localStorageGet("deviceIdUa");
      let data = {
        ts: new Date().getTime(),
        app_id: this.urlData.appid,
        cch_id: this.urlData.pid,
        md_id: this.urlData.md_id,
        time_zone: this.$Base.timeZone(),
        nonce: this.$Base.nonce(12),
        version: this.$Base.getVersion(),
        device_id: deviceIdUa,
        sdk_ver: this.$Base.sdkVer(),
        sys_language: this.$Storage.localStorageGet("lang"),
      };
      data.sign = RSSign(data, data.app_id);
      this.$SyModel
        .init(data)
        .then((res) => {
          if (res.code == 200) {
            let api = res.data.api;
            this.$Storage.localStorageSet("api", JSON.stringify(api));
            this.initialization = true;
            this.$Storage.localStorageSet("kfUrl", res.data.web.kf.kf);
            this.$Storage.localStorageSet(
              "verifiedUrl",
              res.data.web.id_certificate_page
            );
            this.$Storage.localStorageSet(
              "kfApi",
              JSON.stringify(res.data.web)
            );
            this.$Storage.localStorageSet(
              "user_protocol",
              res.data.web.treaty.user_protocol
            );
            this.$Storage.localStorageSet(
              "private_protocol",
              res.data.web.treaty.private_protocol
            );
            this.isMsgVal = 1;
            // 收集设备信息接口
            this.$Report.webDevice(
              this.urlData.pid,
              this.urlData.appid,
              this.urlData.ukey
            );
            // 用户信息
            let XHUWEBSDK = this.$Storage.localStorageGet("_XH_U_WEBSDK");
            if (!XHUWEBSDK) {
              console.log("未登录");
            } else {
              // 如果登陆了就直接跳转到游戏页
              // window.location.href = `/global?ukey=${this.urlData.ukey}&appid=${this.urlData.appid}&pid=${this.urlData.pid}&md_id=${this.urlData.md_id}`;
            }
          } else {
            let errorMsg = res.msg.replace(/\[.*?\]/g, "");
            this.$toast(errorMsg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  created() {
    // let pdSys = this.$Base.checkSysteam();
    // console.log('pdSys',pdSys)
    // if(pdSys == 'PC') {
    //   const installedFrom = this.$Storage.localStorageGet("installedFrom");
    //   if (installedFrom && this.$Storage.localStorageGet("cs") == "true") {
    //     this.$Storage.localStorageSet("cs", "false");
    //     window.location.href = window.location.pathname + installedFrom;
    //   } else {
    //     this.$Storage.localStorageSet("cs", "true");
    //     // No install page saved, send them to the home page?
    //   }
    // }
    // 把页面链接存起来支付的时候需要调用
    this.$Storage.setCookie("msrGameUrl", window.location.href, 7);
    const installedFrom = this.$Storage.localStorageGet("installedFrom");
    if (installedFrom && this.$Storage.localStorageGet("cs") == "true") {
      this.$Storage.localStorageSet("cs", "false");
      window.location.href = window.location.pathname + installedFrom;
    } else {
      this.$Storage.localStorageSet("cs", "true");
      // No install page saved, send them to the home page?
    }
    let urlData = this.$Base.parseUrl(window.location.href); // canshu
    this.urlData = urlData;
    // 初始化
    let deviceIdUa = this.$Storage.localStorageGet("deviceIdUa");
    if (!deviceIdUa) {
      this.$Storage.localStorageSet(
        "deviceIdUa",
        RSMD5(this.$Base.timeSiginUa())
      );
      if (this.urlData.ukey.length != 32) {
        alert(this.$t.message.urlError);
      } else {
        this.init();
      }
    } else {
      console.log("deviceIdUa 存在");
      if (this.urlData.ukey.length != 32) {
        alert(this.$t.message.urlError);
      } else {
        this.init();
      }
    }
    // 判断系统，根据返回值上报对应的按钮名字
    this.isSystem = this.$Base.checkSysteam();
  },
};
</script>

<style lang="scss" src="./style.scss" scoped></style>
